import * as React from "react";

export const SearchIcon = ({ onClick, props }: any) => {
  return (
    <svg
      width={15}
      height={15} 
      viewBox="0 0 15 15" 
      fill="none" {...props}
      onClick={onClick}
      >
      <g
        opacity={0.5}
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6.778 12.556A5.778 5.778 0 106.778 1a5.778 5.778 0 000 11.556zM14 14l-3.143-3.142" />
      </g>
    </svg>
  );
};
